module.exports = __webpack_public_path__ + "img/feature-6.f1fb4050.png";